import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/lib/jenkins/workspace/mdm.softminds.net/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/var/lib/jenkins/workspace/mdm.softminds.net/layouts/empty.vue").then(m => m.default || m))
}